var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"requestLoading"},[_c('div',{staticClass:"requestLoading-box"},[_c('img',{staticClass:"box-img",attrs:{"src":require("@/assets/image/requestLoading.png"),"alt":"loading"}}),_c('h2',{staticClass:"box-h2"},[_vm._v("教學平台開啟中，請耐心等候。")]),_c('h5',{staticClass:"box-h5"},[_vm._v("The platform is loading. Thank you for your patience.")])])])
}]

export { render, staticRenderFns }